import React, { useState, useMemo, useRef, useEffect } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';

import { isEmpty, isArray } from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import qs from 'querystring';
import { Spinner } from '~/components';
import api from '~/services/api';
import { number } from '~/helpers';
import { Table } from '~/components';
import * as S from './styles';


export default function ConfirmationDialogRaw({
  valueProp,
  open,
  mensagem,
  titulo,
  textoBtnOK,
  textoBtnCancel,
  onClose,
  data,
  separadas,
  modal,
  empenho,
  username,
  password
}) {
  //const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [empenhoDia, setEmpenhoDia] = useState({ empenho });
  const [usernameDia, setUsernameDia] = useState("");
  const [passwordDia, setPasswordDia] = useState("");

  const empenhoDiaRef = useRef(null);
  const usernameDiaRef = useRef(null);
  const passwordDiaRef = useRef(null);

  // const resultado = data.filter(obj1 => !separadas.some(obj2 => obj1.fatu_codigo === obj2.fatu_codigo));


  useEffect(() => {
    setUsernameDia('');
    setPasswordDia('')
  }, [open]);


  const cellsProfilesSeparados = useMemo(
    () => [
      { id: 'fatu_codigo', label: 'Pré-fatura', },
      { id: 'orga_nome', label: 'Órgão' },
      {
        id: 'fatu_valor_servico',
        label: 'Valor do Serviço (R$)',
        align: 'right',
        format: (value) => number(value, 'currency'),
      },
      {
        id: 'fatu_total_retencao',
        label: 'Total das retenções (R$)',
        align: 'right',
        format: (value) => number(value, 'currency'),
      },
      {
        id: 'fatu_equipamentos_faturados',
        label: 'Quantidade veículos faturados',
        align: 'right',
      },
      {
        id: 'fatu_equipamentos_instalados',
        label: 'Quantidade veículos instalados',
        align: 'right',
      },
    ],
    []
  );

  const cellsProfiles = useMemo(
    () => [
      { id: 'fatu_codigo', label: 'Pré-fatura', },
      { id: 'orga_nome', label: 'Órgão' },
      {
        id: 'fatu_valor_servico',
        label: 'Valor do Serviço (R$)',
        align: 'right',
        format: (value) => number(value, 'currency'),
      },
      {
        id: 'fatu_total_retencao',
        label: 'Total das retenções (R$)',
        align: 'right',
        format: (value) => number(value, 'currency'),
      },
      {
        id: 'fatu_equipamentos_faturados',
        label: 'Quantidade veículos faturados',
        align: 'right',
      },
      {
        id: 'fatu_equipamentos_instalados',
        label: 'Quantidade veículos instalados',
        align: 'right',
      },
    ],
    []
  );

  function somarValoresTop(json1, json2, coluna) {
    const filtrados = json1.filter(obj1 => !json2.some(obj2 => obj1.fatu_codigo === obj2.fatu_codigo));
    return json1.reduce((somaTotal, item) => {
      const encontrado = filtrados.find(elem => elem.fatu_codigo === item.fatu_codigo);
      if (encontrado) {
        return somaTotal + Number(encontrado[coluna]);
      }
      return somaTotal;
    }, 0);
  }

  function somarValores(json1, coluna) {
    return json1.reduce((somaTotal, item) => {
      const encontrado = json1.find(elem => elem.fatu_codigo === item.fatu_codigo);
      if (encontrado) {
        return somaTotal + Number(encontrado[coluna]);
      }
      return somaTotal;
    }, 0);
  }

  const resultadoSomaJuntosfatu_total_retencao = somarValores(separadas, 'fatu_total_retencao');
  const resultadoSomaJuntosfatu_valor_servico = somarValores(separadas, 'fatu_valor_servico');
  const resultadoSomaJuntosfatu_equipamentos_faturados = somarValores(separadas, 'fatu_equipamentos_faturados');


  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);



  useEffect(() => {
    if (usernameDiaRef.current != null) {
      usernameDiaRef.current.focus();
    }
  }, []);


  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    try {
      setIsLoading(true);
      onClose();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleOk = async () => {

    if (isEmpty(empenhoDia)) {
      toast.error('O campo empenho é obrigatório!');
      empenhoDiaRef.current.focus();
      return;
    }
    if (isEmpty(usernameDia)) {
      toast.error('O campo login é obrigatório!');

      if (usernameDiaRef.current != null) {
        usernameDiaRef.current.focus();
      }
      return;
    }
    if (isEmpty(passwordDia)) {
      toast.error('O campo senha é obrigatório!');
      if (passwordDiaRef.current != null) {
        passwordDiaRef.current.focus();
      }
      return;
    }



    if ((String(usernameDia).trim().toUpperCase()) !== (String(username).trim().toUpperCase())) {
      toast.error('O login diferente do digitado na tela anterior!');
      if (usernameDiaRef.current != null) {
        usernameDiaRef.current.focus();
      }
      return;
    }


    try {
      const wherefield = [];
      const valuewherefield = [];
      const typewherefield = [];
      wherefield.push('usua_login');
      valuewherefield.push(usernameDia);
      typewherefield.push("IGUAL");
      const search = { wherefield, valuewherefield, typewherefield };
      const { data } = await api.get('/usuariomaster', {
        params: { ...search, pagesize: 99999, pesquisalista: true, page: 1, },
        paramsSerializer: (param) => qs.stringify(param),
      });
      const { items } = data;
      if (!isEmpty(items)) {
        if (passwordDia !== items[0].usua_senha) {
          toast.error('Falha na autenticação do usuário! Login ou senha inválidos!');
          if (passwordDiaRef.current != null) {
            passwordDiaRef.current.focus();
          }
          return;
        }
      } else {
        toast.error('Falha na autenticação do usuário! Login ou senha inválidos!');
        if (passwordDiaRef.current != null) {
          passwordDiaRef.current.focus();
        }
        return;
      }
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
    }
    const recordResult = {
      acao: value,
      login: usernameDia,
      senha: passwordDia,
      empenho: empenhoDia,
    };

    try {
      setIsLoading(true);
      onClose(recordResult);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  //const isSelected = (name) => selected.indexOf(name) !== -1;
  return (
    <div>
      {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
        ''
      )}

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={modal}
        onEntering={handleEntering}
        aria-labelledby="confirmation-dialog-title"
        open={open}
        PaperProps={{
          style: {
            height: '75vh',  // Define a altura do dialog
            width: '130vh',
            maxHeight: 'none',  // Remove o limite de altura
            // maxWidth: 'none',
          },
        }}
      >
        <DialogTitle id="confirmation-dialog-title">{titulo}</DialogTitle>
        <DialogContent dividers>

          {/* <span>{mensagem}</span> */}
          <br />

          <S.WrapperCab>
            <TextField
              disabled
              size="small"
              variant="outlined"
              label="Empenho"
              value={empenho}
              inputRef={empenhoDiaRef}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Login"
              value={usernameDia}
              autoFocus
              onChange={({ target }) => setUsernameDia(target.value)}
              inputRef={usernameDiaRef}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Senha"
              value={passwordDia}
              onChange={({ target }) => setPasswordDia(target.value)}
              inputRef={passwordDiaRef}
              type="password"
            />
          </S.WrapperCab>

          <br />

          <span>Faturas separadas</span>
          <Table
            size="small"
            cells={cellsProfilesSeparados}
            data={separadas}
            loading={loading}
            // onCallback={handleGetChildrensAPI}
            paginate={99999}
            maxHeight={300}
            showPagination={false}
          />
          <span>Total de registros: {separadas.length}</span>

          <br />
          <br />
          <span>Valor do Serviço (R$): {number(resultadoSomaJuntosfatu_valor_servico, 'currency')}</span>
          <br />
          <span>Total das retenções (R$): {number(resultadoSomaJuntosfatu_total_retencao, 'currency')}</span>
          <br />
          <span>Quantidade veículos faturados: {resultadoSomaJuntosfatu_equipamentos_faturados}</span>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk} color="primary" variant="outlined"> {textoBtnOK} </Button>
          <Button autoFocus onClick={handleCancel} color="secondary" variant="outlined"> {textoBtnCancel} </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


ConfirmationDialogRaw.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  valueProp: PropTypes.string.isRequired,
  mensagem: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  textoBtnOK: PropTypes.string.isRequired,
  textoBtnCancel: PropTypes.string.isRequired,
  modal: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']),
  empenho: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,

};

ConfirmationDialogRaw.defaultProps = {
  valueProp: '',
  open: false,
  mensagem: '',
  titulo: 'CONFIRMAR',
  textoBtnOK: 'Ok',
  textoBtnCancel: 'Cancel',
  modal: 'xs',
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  separadas: PropTypes.objectOf(PropTypes.any).isRequired,
  empenho: '',
  username: '',
  password: '',
};
